import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge32 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='年会費の勘定科目・経費算入の可否' fontWeight={700} />
                <p>
                    ゴルフ会員権の<a href='/knowledge/11'>年会費の基本的な仕組みや支払えなくなった場合の対処法</a>
                    についてはすでにご紹介していますが、経理担当の方が実務で最も迷うのは「年会費をどの勘定科目で処理すればよいか」「全額を経費として損金算入できるのか」という点です。
                    <br />
                    本記事では、年会費の勘定科目の決まり方と、経費算入にあたっての注意点を具体的に解説します。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='年会費の勘定科目は「入会金の処理方法」で決まる' fontWeight={700} />
                <p>
                    法人税基本通達9-7-13では、法人がゴルフクラブに支出する年会費・年決めロッカー料その他の費用（名義書換料を含み、プレーに直接要する費用を除きます）について、入会金の処理方法に連動させる形で取り扱いを定めています。
                </p>

                <Heading3 title='入会金を資産計上している場合：交際費' />
                <p>
                    法人会員として入会し、入会金（名義書換料）を資産計上している場合、その後毎年発生する年会費は原則として「交際費」で処理します。
                    <br />
                    資産計上した入会金そのものは減価償却の対象にはならず、売却または退会するまで貸借対照表に資産として残ります。一方で、年会費は毎期発生する費用のため、交際費として損金の額に算入することになります（法人税基本通達9-7-11・9-7-13）。
                </p>

                <Heading3 title='入会金を給与処理している場合：給与' />
                <p>
                    記名式の法人会員で、特定の役員・使用人が専ら私的に利用しているなど、入会金を給与として処理している場合は、その後の年会費も同じ人物に対する給与として扱います。
                    <br />
                    給与として処理すると、その役員・使用人個人の給与所得に加算され、所得税・住民税・社会保険料の計算に影響する点に注意が必要です。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='個人事業主が年会費を経費にする場合の注意点' fontWeight={700} />
                <p>
                    個人事業主が事業用にゴルフ会員権を保有し、取引先との接待や情報交換の場として利用している場合、年会費を必要経費に算入できる余地があります。
                    <br />
                    ただし、プライベートのプレーと事業目的のプレーが混在している場合は、家事関連費（事業と私生活の両方に関わる費用）として按分が必要になることがあります。
                    <br />
                    経費として認められるためには、いつ・誰と・どのような事業上の目的でゴルフ会員権を利用したかを記録（接待の相手先や商談内容のメモなど）として残しておくことが重要です。記録が無いまま全額を経費計上すると、税務調査の際に否認されるリスクが高まります。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='交際費として計上する際の損金算入限度額' fontWeight={700} />
                <p>
                    年会費を交際費として処理する場合、法人税法上の交際費等の損金不算入制度の対象になります。
                    <br />
                    資本金1億円以下の中小法人については、租税特別措置法の交際費等の損金算入の特例により、年800万円までの交際費等を全額損金算入するか、接待飲食費の50％相当額を損金算入するかを選択できる仕組みが設けられています（適用対象・上限額・適用期限は改正で変わることがあるため、最新の要件は顧問税理士にご確認ください）。
                    <br />
                    ゴルフ場の年会費自体は「接待飲食費」には該当せず、通常の交際費として上記の年800万円枠の中で管理する必要があるため、他の交際費支出と合算して限度額を超えないか確認しておきましょう。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='年会費にかかる消費税の扱い' fontWeight={700} />
                <p>
                    年会費はゴルフ場の施設利用等に対する役務提供の対価にあたるため、消費税の課税対象です。課税事業者であれば、支払った年会費は原則として課税仕入れとして仕入税額控除の対象になります。
                    <br />
                    売却時の消費税の取り扱いなど、ゴルフ会員権にまつわる消費税の仕訳については
                    <a href='/knowledge/33'>ゴルフ会員権売却時の消費税・仕訳（法人・個人別）</a>
                    で詳しく解説していますので、あわせてご確認ください。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='まとめ' fontWeight={700} />
                <p>
                    年会費の勘定科目は、入会金を資産計上しているか給与処理しているかによって「交際費」か「給与」かが決まります。交際費として処理する場合は、中小法人の損金算入限度額の枠内に収まっているかも確認が必要です。
                    <br />
                    経理処理に迷う場合は、顧問税理士に加えて、会員権の取得・売却の経緯に詳しい会員権業者にも相談すると、実務上の判断がしやすくなります。
                    <br />
                    年会費が払えなくなった場合の対処法など、年会費に関する基礎知識は
                    <a href='/knowledge/11'>こちら</a>でご紹介しています。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge32;
